<template>
    <div id="wrapper" class="position-relative w-100 overflow-hidden">
		<main id="main" class="py-60">
			<div class="container">
				<div class="box-shadow position-relative pt-50 pb-40">
					<h2 class="text-center mb-35">Step 2<span class="text-light-blue d-block">Please provide the flight information</span></h2>
					<ValidationObserver v-slot="{ handleSubmit }">
					<form action="#" v-on:submit.prevent="handleSubmit(saveTrip)" class="main-form needs-validation text-pearl" >
						<div class="form-row mb-28">


							<div class="col-md-6 mb-18">
								<ValidationProvider mode="eager" name="From" rules="required" v-slot="{ errors }">
								<Autocomplete
										:items="airportsFromQuery"
										v-model="airportFrom"
										:get-label="getLabel"
										:component-item='template'
										:input-attrs="fromInput"
										@input="refreshDistance"
										@change="clearClassFrom">
								</Autocomplete>
								<!-- <div class="valid-feedback">Looks good!</div> -->
								<div class="invalid-feedback">{{ errors[0] }}</div>
								</ValidationProvider>
							</div>


							<div class="col-md-6 mb-18">
								<ValidationProvider mode="eager" name="To" rules="required" v-slot="{ errors }">
								<Autocomplete
										:items="airportsToQuery"
										v-model="airportTo"
										:get-label="getLabel"
										:component-item='template'
										:input-attrs="toInput"
										@input="refreshDistance"
										@change="clearClassTo">
								</Autocomplete>
								<!-- <div class="valid-feedback">Looks good!</div> -->
								<div class="invalid-feedback">{{ errors[0] }}</div>
								</ValidationProvider>
							</div>


							<div class="col-6 mb-18">
								<span v-if="travelTime" class="bg-light-blue text-white d-inline-block align-top border rounded px-20 py-9">{{ travelTime }}</span>
								<span v-else class="bg-light-blue text-white d-inline-block align-top border rounded px-20 py-9"> --- Hrs.</span>
								<span v-if="distance" class="bg-light-blue text-white d-inline-block align-top border rounded px-20 py-9"> {{ roundNumber(distance) }} Miles</span>
								<span v-else class="bg-light-blue text-white d-inline-block align-top border rounded px-20 py-9"> --- Miles</span>
							</div>


							<div class="col-6 mb-18">
							</div>


							<div class="col-md-6 mb-30">
								<ValidationProvider mode="aggressive" name="Departure Date and Time" rules="required" v-slot="{ errors }">
									<date-picker
												type=datetime
												ref="dateTimePicker"
												:editable="false"
												:input-class="'form-control date-picker-trips text-left'"
												format="MM-DD-YYYY HH:mm A"
												class="w-100 input-group"
												v-model="departureDateTime"
												valueType="format"
												:default-value="tomorrow()"
												:placeholder="'Departure Date and Time'"
												:disabled-date="beforeToday">
									</date-picker>
									<div class="invalid-feedback">{{ errors[0] }}</div>
								</ValidationProvider>
							</div>


							<div class="col-md-6 mb-30">
								<ValidationProvider name="Flight's Total Price" rules="required|numeric" v-slot="{ errors }">
									<input v-model="price" type="text" class="form-control" placeholder="Flight's Total Price">
									<div class="invalid-feedback">{{errors[0]}}</div>
								</ValidationProvider>
							</div>


							<div class="col-md-12 mb-30">
								<ValidationProvider mode="eager" name="Plane" rules="required" v-slot="{ errors }">
									<Autocomplete
										:items="aircraftsQuery"
										v-model="aircraft"
										:get-label="getAircraftLabel"
										:component-item='aircraftTemplate'
										:input-attrs="aircraftInput"
										@change="clearClassAircraft">
									</Autocomplete>
									<div class="invalid-feedback">
										{{ errors[0] }}
									</div>
								</ValidationProvider>
							</div>

							<div v-if="displayTextArea" class="col-md-12 mb-30">
									<textarea placeholder="Note" class="form-control" v-model="description" rows="3"></textarea>
							</div>
							
							
							<div class="col-md-6 ">
								<div class="seat-input form-group d-flex align-items-center justify-content-md-end mb-30 mb-md-20">
									<ValidationProvider v-if="userIsBusiness" name="Seats Booked" rules="required|min_value:0|integer" v-slot="{ errors }">
										<label for="passengersInput">Seats Booked:</label>
											<div class="input-wrapper mr-35 ml-15">
												<input id="passengersInput" v-model="passengers" type="text" autocomplete="off" class="form-control num">
											</div>
											<span class="invalid-feedback">{{ errors[0] }}</span>
									</ValidationProvider>
									<ValidationProvider v-else name="Seats Booked" rules="required|empty_leg_restriction|min_value:1|integer" v-slot="{ errors }">
										<label for="passengersInput">Seats Booked:</label>
											<div class="input-wrapper mr-35 ml-15">
												<input id="passengersInput" v-model="passengers" type="text" autocomplete="off" class="form-control num">
											</div>
											<span class="invalid-feedback">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="seat-input form-group d-flex align-items-center justify-content-md-end position-relative mb-30 mb-md-0">
									<ValidationProvider name="Seat Capacity" rules="required|integer|greaterthan:@Seats Booked" v-slot="{ errors }">
										<label for="capacityInput">Seat Capacity:</label>
										<div class="input-wrapper mr-35 ml-15">
											<input id="capacityInput" v-model="capacity" autocomplete="off" type="text" class="form-control num">
										</div>
										<span class="invalid-feedback">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
							</div>
							<div class="col-md-6">
								<div class="d-flex justify-content-md-end align-items-center py-md-8 mb-25">
									<span>Pets allowed:</span>
									<div class="custom-control custom-radio custom-control-inline">
										<input v-model="petsAllowed" type="radio" id="customRadioInline1" class="custom-control-input" :value="true">
										<label class="custom-control-label" for="customRadioInline1">Yes</label>
									</div>
									<div class="custom-control custom-radio custom-control-inline mr-0">
										<input v-model="petsAllowed" type="radio"  id="customRadioInline2" class="custom-control-input" :value="false">
										<label class="custom-control-label" for="customRadioInline2">No</label>
									</div>
								</div>
								<div class="d-flex justify-content-md-end align-items-center py-md-8">
									<span>Minors allowed:</span>
									<div class="custom-control custom-radio custom-control-inline">
										<input v-model="minorsAllowed" type="radio" id="customRadioInline3" name="customRadioInline2" class="custom-control-input" :value="true">
										<label class="custom-control-label" for="customRadioInline3">Yes</label>
									</div>
									<div class="custom-control custom-radio custom-control-inline mr-0">
										<input v-model="minorsAllowed" type="radio" id="customRadioInline4" name="customRadioInline2" class="custom-control-input" :value="false">
										<label class="custom-control-label" for="customRadioInline4">No</label>
									</div>
								</div>
							</div>
						</div>
						<div class="text-center">
							<button class="btn btn-primary px-40" type="submit">Submit</button>
						</div>
					</form>
					</ValidationObserver>
					<router-link to="/trip/create" class="back-btn text-light-blue position-absolute"><i class="icon-arrow-thin-left"></i></router-link>
				</div>
			</div>
		</main>
	</div>
</template>
<script>
	import httpClient from '@/utils/httpClient';
	import axios from 'axios';
	import AirportTemplate from '../Templates/AirportTemplate';
	import AircraftTemplate from '../Templates/AircraftTemplate';
	import Autocomplete from 'v-autocomplete';
	import DatePicker from 'vue2-datepicker';
	import 'vue2-datepicker/index.css';
	import 'v-autocomplete/dist/v-autocomplete.css';
	import moment from 'moment'; 


export default {
	components:{
		Autocomplete,
		DatePicker
	},
	mounted() {
		this.passengers = this.userIsBusiness ? 0 : 1;
	},
	data() {
		return {
			submitting:false,
			airportsFromQuery:[],
			airportsToQuery:[],
			aircraftsQuery:[],
			airportFrom:null,
			airportTo:null,
			aircraft:null,
			capacity:6,
			passengers:null,
			departureDateTime:'',
			distance:null,
			description:null,
			existingTrip:null,
			price:null,
			petsAllowed:true,
			minorsAllowed:true,
			travelTime:null,
			invalidFrom:false,
			invalidTo:false,
			template: AirportTemplate,
			aircraftTemplate: AircraftTemplate,
			fromInput: {
				placeholder:'From',
				class:'form-control',
				id:'from-input',
				autocomplete:'off',
			},
			toInput: {
				placeholder:'To',
				class:'form-control',
				id:'to-input',
				autocomplete:'off',
			},
			aircraftInput: {
				placeholder:'Plane',
				class:'form-control',
				id:'aircraft-input',
				autocomplete:'off',
			}
		}
	},
	methods: {
		beforeToday(date) {
      return date < new Date(new Date().setHours(0,0,0,0));
		},
		clearClassFrom(text) {
			let savedQuery = document.getElementById('from-input').value;
			setTimeout(() => {
				if (document.getElementById('from-input').value === savedQuery && document.getElementById('from-input').value.length > 0) {
					this.updateAirportsFrom(document.getElementById('from-input').value);
				}
			}, 400)
			
			if (text == "") {
				this.invalidFrom = false;
				this.fromInput.class = 'form-control';
				this.airportsFromQuery = [];
			}
		},
		clearClassTo(text) {
			let savedQuery = document.getElementById('to-input').value;
			setTimeout(() => {
				if (document.getElementById('to-input').value === savedQuery && document.getElementById('to-input').value.length > 0) {
					this.updateAirportsTo(document.getElementById('to-input').value);
				}
			}, 400)

			if (text == "") {
				this.invalidTo = false;
				this.toInput.class = 'form-control';
				this.airportsToQuery = [];
			}
		},
		clearClassAircraft(text) {
			let savedQuery = document.getElementById('aircraft-input').value;
			setTimeout(() => {
				if (document.getElementById('aircraft-input').value === savedQuery && document.getElementById('aircraft-input').value.length > 0) {
					this.updateAircrafts(document.getElementById('aircraft-input').value);
				}
			}, 400)

			if (text == "") {
				this.invalidTo = false;
				this.toInput.class = 'form-control';
				this.airportsToQuery = [];
			}
		},
		getLabel(item) {
			if (item) {
				return item.name;	
			}
			else {
				this.airportsToQuery = [];
				return null;
			}
		},
		getAircraftLabel(item) {
			if (item) {
				return item.name;	
			}
			else {
				this.airportsToQuery = [];
				return null;
			}
		},
		getFormattedDate(date) {
			return moment(date,'MM-DD-YYYY HH:mm A').format('YYYY-MM-DD');
		},
		getNewTripParams() {
			let params = {
				flies_from: this.airportFrom.id,
				flies_to: this.airportTo.id,
				flight_distance : this.roundNumber(this.distance),
				capacity: this.capacity,
				passengers: this.passengers,
				host_id: this.$store.state.users.user.id,
				aircraft_id: this.aircraft.id,
				minors_allowed: this.minorsAllowed,
				pets_allowed: this.petsAllowed,
				departure_date: moment(this.departureDateTime,'MM-DD-YYYY HH:mm A').format('YYYY-MM-DD'),
				departure_time: moment(this.departureDateTime,'MM-DD-YYYY HH:mm A').format('HH:mm'),
				price: this.price,
				description: this.description,
			}
			return params;
		},
		getTravelTime() {
			let decimalTime = this.distance/500 + 0.5;
			let hours = this.getEstimatedHours(decimalTime);
			let label = '';
			if (hours > 1) {
				label = hours+" hours ";
			}
			else if (hours == 1) {
				label = hours+" hour ";
			}

			let minutes = this.getEstimatedMinutes(decimalTime)
			if (minutes > 0 && minutes < 60) {
				label += minutes+' min';
			}
			else if (minutes == 60) {
				label += '55 min';
			}
			return label;
		},
		getEstimatedHours(decimalTime) {
			return Math.trunc(decimalTime);
		},
		getEstimatedMinutes(decimalTime) {
			return Math.ceil(((decimalTime % 1)*60)/5)*5;
		},
		notMoreThanTwentyHours(date) {
			return date > new Date(new Date().setHours(20, 0, 0, 0));
		},
		updateAirportsFrom(text) {
				if (text) {
					axios.get("/api/airports/search?filter[search]="+text)
					.then((res) => {
						this.airportsFromQuery = res.data.data.airports;
						//Don't show already selected airport
						this.airportsFromQuery = this.airportTo ?
						this.airportsFromQuery.filter(airport => airport.id !== this.airportTo.id) :
						this.airportsFromQuery;
						if (this.airportsFromQuery.length == 0 ) {
							this.invalidFrom=true;
							this.fromInput.class = 'form-control is-invalid';
						}
					});
				}
		},
		updateAirportsTo(text) {
				if (text) {
					axios.get("/api/airports/search?filter[search]="+text).then((res) => {
						this.airportsToQuery = res.data.data.airports;
						//Don't show already selected airport
						this.airportsToQuery = this.airportFrom ?
						this.airportsToQuery.filter(airport => airport.id !== this.airportFrom.id) :
						this.airportsToQuery;
						if (this.airportsToQuery.length == 0) {
							this.invalidTo=true;
							this.toInput.class = 'form-control is-invalid';
						}
					});
				}
		},
		updateAircrafts(text) {
				if (text) {
					axios.get("/api/aircrafts?filter[search]="+text).then(res => this.aircraftsQuery = res.data.data.aircrafts);
				}
		},
		refreshDistance() {
			if (!this.airportFrom || !this.airportTo) {
				this.distance = null;
			}	
			else {
				this.updateDistance();
			}
		},
		updateDistance() {
			axios.get("/api/distance/"+this.airportFrom.id+"/"+this.airportTo.id).then(res => {
				this.distance = res.data.miles;
				this.travelTime = this.getTravelTime();
			});
		},
		roundNumber(value) {
			return Math.ceil(value);
		},
		createTrip() {
			httpClient.post("/api/planned-trip", this.getNewTripParams()).then(() =>  {
				if (process.env.VUE_APP_ENV == 'production') {
					window.ga('send', 'event', 'Lead', 'Planned');
				}
				this.$swal({ title:'OK',icon:'success',text: "The Trip has been Created"})
				.then(() => this.$router.replace('/trip/search'));
				});
		},
		saveTrip() {
			if (!this.submitting) {
				this.submitting = true;
				httpClient.get("/api/trip/exists/planned?flies_from="+this.airportFrom.id+"&flies_to="+this.airportTo.id+
				"&filter[between]="+this.getFormattedDate(this.departureDateTime)+","+this.getFormattedDate(this.departureDateTime)+"&filter[afterToday]=1")
				.then((res) =>  {
					if (res.data) {
						this.existingTrip = res.data;
						this.$swal({
							title:'Are you sure?',
							icon:'warning',
							text: "A trip with that parameters already exists. What do you want to do?",
							showCancelButton: true,
							confirmButtonText: 'Join a flight',
							cancelButtonText: 'Change Trip Parameters',
							allowOutsideClick: false
							})
							.then((result) => {
								//Join a flight
								if (result.value) {
									this.$router.push({ name: 'TripDetail', params: { trip:this.existingTrip.id } })
								}
								else {
									this.submitting = false;
								}
							})	
					}
					else {
						//No trips with the entered parameters have been created.
						this.createTrip();
					}
				});
			}
		},
		tomorrow() {
			var tomorrow = new Date();
			tomorrow.setDate(new Date().getDate()+1);
			tomorrow.setHours(0,0,0,0);
			return tomorrow;
		}
	},
	computed: {
		userIsBusiness: function () {
			return this.$store.state.users.user.role.name == 'business' || this.$store.state.users.user.role.name == 'broker';
		},
		displayTextArea:function() {
			return this.$store.state.users.user && Boolean(this.$store.state.users.user.email == "emptyleg@sharedcharter.com" || this.$store.state.users.user.email == "emptylegs@sharedcharter.com");
		}
	}
}
</script>

<style>

	.seat-input span {
		display: flex;
		flex-flow: wrap;
		align-items: center;
	}

	.invalid-feedback {
		display: block;
	}
	
	.v-autocomplete-list {
		background-color: white;
		border: solid black 1px;
		z-index: 1;
		color: black;
	}
	

</style>